export const GoodsFormOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  columnBtn: true,
  viewBtn: false,
  menuWidth: "200",
  labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "名称",
      prop: "name",
      type: "input",
      search: true,
      span: 13,
      placeholder: "请输入价格配置名称",
    },
    {
      label: "创建人",
      prop: "createBy",
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
      width: "110",
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },

    {
      label: "更新时间",
      prop: "updateTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
  ],
};
